// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__Rj1aC","desabilitar":"OptionSelect_desabilitar__FGdah","focado":"OptionSelect_focado__hiBOa","novo":"OptionSelect_novo__FN0FW"};